var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMuted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.15 21.675-3-3q-.425.25-.875.463-.45.212-.925.362v-1.05q.3-.1.563-.225.262-.125.512-.275l-3.85-3.85v3.475L8 14H4.575v-4h2.9L2.6 5.125l.7-.7 16.55 16.55Zm-.775-5-.7-.7q.6-.85.938-1.875.337-1.025.337-2.125 0-2.2-1.262-3.975-1.263-1.775-3.338-2.5V4.45q2.5.8 4.05 2.862 1.55 2.063 1.55 4.663 0 1.3-.412 2.5-.413 1.2-1.163 2.2ZM15.6 13.9l-1.25-1.25v-4q.85.55 1.287 1.45.438.9.438 1.9 0 .5-.125.988-.125.487-.35.912Zm-4.025-4.025L9.85 8.15l1.725-1.725Zm-1 5.275V13.1l-2.1-2.1h-2.9v2h2.85Zm-1.05-3.1Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMuted);
export default __webpack_public_path__ + "static/media/IconMuted.27dd4dfe937fa7277b5dcfec8248667a.svg";
export { ForwardRef as ReactComponent };